<template>

<app-panel-content :slim="true" :grow="true">

    <app-panel-title :text="item.name" :is-big="true" />
    
	<app-panel-summary label="First name" :value="item.firstname" />
    
	<app-panel-summary label="Last name" :value="item.lastname" />
    
	<app-panel-summary label="E-mail" :value="item.email" />
            
</app-panel-content>

</template>

<script>

export default {

    props: ['item']

}

</script>

<style scoped>

</style>
